import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import Amplify, { Auth } from "aws-amplify";
import awsconfig from "./.aws-config/awsconfig";
import awsauth from "./.aws-config/awsauth";

const origin = window.location.origin;
const awsConfig = {
  ...awsconfig,
  redirectSignIn: origin,
  redirectSignOut: origin,
};
// After Cognito pool migration (May 2026), dev + prod share the same
// App Client ID. Dev mode bypasses Cognito entirely via REACT_APP_DEV_USER_ID,
// so the client just needs to be a valid one in the new pool.

const authConfig = {
  ...awsauth,
  redirectSignIn: origin,
  redirectSignOut: origin,
};
Amplify.configure(awsConfig);
Auth.configure({ oauth: authConfig });

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
